var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.productVariantData)?_c('ProductContentTabs',{attrs:{"productVariantData":_vm.productVariantData,"viewMode":_vm.viewMode,"purchased":_vm.purchased}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }